import EvComponent from "@transformd-ltd/electronic-verification";
import Formatic, { Data, Overrides } from "@transformd-ltd/sdk";
import React from "react";
import ReactDOM from "react-dom";
import {
  Collapsable,
  NavigationController,
} from "../../customComponent/DefaultForm";
import { ParamsFromURL } from "../../javascript/common";
import TimePicker from "../../customComponent/TimePicker";

const params = ParamsFromURL();
let data;

export function createForm(
  formContainer,
  formApiKey,
  formId,
  formBranch,
  formChannel,
  formConfig,
  initialValues = {}
) {
  data = new Data();

  const Form = () => {
    return (
      <Formatic
        data={data}
        formId={formId}
        apiKey={formApiKey}
        environment={formBranch}
        config={formConfig}
        channel={formChannel}
        submissionId={params.submissionID}
        serverUrl="https://api.transformd.com/graphql"
        apiServerUrl="https://api.transformd.com"
        subscriptionServerUrl="wss://api.transformd.com/subscriptions"
        initialValues={initialValues}
        theme="transformd"
        runReduxDevTools={process.env.NODE_ENV === "development"}
      >
        <Overrides.OverrideFieldContainer
          component={Collapsable}
          type="collapsable"
          getData={getDataHelper}
        />
        <Overrides.OverrideFieldContainer
          component={EvComponent}
          type="electronicVerification"
        />
        <Overrides.OverrideFieldContainer
          component={TimePicker}
          type="timePicker"
          getData={getDataHelper}
        />
        <Overrides.OverrideFieldContainer
          component={NavigationController}
          type="navigationController"
          getData={getDataHelper}
          channel={formChannel}
        />
      </Formatic>
    );
  };

  ReactDOM.render(<Form />, document.getElementById(formContainer));
}

export function getDataHelper() {
  return data;
}
